<div class="stores-list">
  <div *ngFor="let store of storesList" class="store-item d-flex flex-items-center" (click)="selectStore(store)">
    <gd-store-type-icon [storeType]="store.type" [size]="48"></gd-store-type-icon>
    <div class="store-name">
      {{ store.name }}
    </div>
  </div>
</div>
